import {QA, SectionDivider} from "@components/Faq/types";
import {useTranslation} from "@i18n/client";

import {useDeepCompareMemo} from "use-deep-compare";
import {getFaqs} from "@components/Faq/getFaqs";
import {Question} from "src/constants/faqIndex";

export const useFaqIndex = (items: (Question | SectionDivider)[]): (QA | SectionDivider)[] => {
  const {t} = useTranslation();
  return useDeepCompareMemo(() => getFaqs(items, t), [items, t]);
};
